import uiService from '../../../services/UIService';
import settingsReader from '../../../store/readHelpers/SettingsReader';
import MathJax2Display from './MathJax2Display';
import MathJax3Display from './MathJax3Display';

const MathDisplay = {
    async showMath(wrapperElement) {
        if (uiService.isMathJax3Supported() && settingsReader.isMathJax3Enabled()) {
            return MathJax3Display.showMathJax3(wrapperElement);
        }
        return MathJax2Display.showMathJax2(wrapperElement);
    },
};

export default MathDisplay;
